import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cinema-feedback__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "错误反馈", -1)
const _hoisted_3 = { class: "cinema-feedback__body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "显示信息", -1)
const _hoisted_5 = { class: "info" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "info-row mt-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "上映时间：", -1)
const _hoisted_9 = {
  key: 0,
  class: "origin info-row mt-24"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "原始信息：", -1)
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 公开网络搜索 ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "信息来源：", -1)
const _hoisted_14 = { class: "origin info-row mt-8" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "文件名称：", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "请选择错误类型", -1)
const _hoisted_17 = { class: "problem" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "补充说明", -1)
const _hoisted_20 = { class: "cinema-feedback__footer" }

import { computed, PropType } from 'vue'
import { useCinemaFeedback } from '@shared/composable/cinema'
import { useCinemaStore } from '@remote/store/cinema'
import { toast } from '@remote/utils'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { checkNetworkState } from '@remote/store/utils'
// import { formatSize } from '@shared/utils/bytes'
import PopWrapper from '@remote/components/PopWrapper.vue'
import global from '@remote/store/constantStore'
import Button from '@remote/components/Button.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  nfo: {
    type: Object as PropType<API_NFO.NFO>,
    required: true,
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const cinemaStore = useCinemaStore()

// const uploadInput = ref<null | HTMLInputElement>(null)





const { isShow, close } = usePromisifyDialog(emit)

const {
  checkProblem,
  currentProblems,
  infoOrigin,
  isProblemChecked,
  isSubmitDisabled,
  problemTypes,
  additionRef,
  userUploadInfo,
} = useCinemaFeedback(computed(() => props.nfo))

const onConfirm = async () => {
  if (isSubmitDisabled.value) return
  if (checkNetworkState()) return

  try {
    const [err, res] = await cinemaStore.submitFeedback(props.nfo, currentProblems.value, additionRef.value, global.userId)
    if (err || res.result !== 'ok') {
      toast(`提交失败:${err?.error_description || res.result}`)
    } else {
      toast('反馈完成')
      close(true)
    }
  } catch(err) {
    toast(`提交失败:${err}`)
  }
}

// type UploadFile = {
//   name: string
//   id: number
//   size: number
//   status: '上传中' | '上传成功' | '上传失败'
//   resultID?: string
// }

// const uploadedFiles = ref<UploadFile[]>([])

// let selfGrowID = 0

// const chooseFile = () => {
//   if (uploadInput.value && uploadedFiles.value.length <= 2) {
//     uploadInput.value.click()
//   }
// }

const showUploadDetail = () => {
  toast(`用户ID: ${props.nfo.scrape_result?.image_upload_info.usernewno ?? ''}`)
}

// const uploadFile = async (evt: InputEvent) => {
//   let files = (evt.target as HTMLInputElement).files
//   if (files && files.length > 0) {
//     const curID = selfGrowID
//     selfGrowID++
//     uploadedFiles.value.push({
//       name: files[0].name,
//       id: curID,
//       size: files[0].size,
//       status: '上传中',
//       resultID: '',
//     })
//     try {
//       let formData = new FormData()
//       formData.append('file', files[0]) // 选择多个，只上传第一个
//       const result = await API?.uploadFeedbackImage(formData)
//       const res = uploadedFiles.value.find(i => i.id === curID)
//       if (res) {
//         res.status = '上传成功'
//         res.resultID = result?.id
//       }
//       toast(`${files[0].name}上传成功`)
//     } catch (err) {
//       const res = uploadedFiles.value.findIndex(i => i.id === curID)
//       if (res > -1) {
//         uploadedFiles.value.splice(res, 1)
//       }
//       toast(`${files[0].name}上传失败，请检查网络`)
//     }
//   }

// }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopWrapper, {
    close: _unref(close),
    "is-show": _unref(isShow)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "cinema-feedback is-dark",
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", {
            class: "cancel",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
          }, "取消"),
          _createElementVNode("span", {
            class: _normalizeClass({
            'submit': true,
            'is-disabled': _unref(isSubmitDisabled)
          }),
            onClick: onConfirm
          }, "提交", 2),
          _createElementVNode("i", {
            class: "icomoon-close head-close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "poster",
              src: __props.nfo?.scrape_result?.poster_vertical ?? ''
            }, null, 8, _hoisted_6),
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, _toDisplayString(__props.nfo?.scrape_result?.trans_name || '无'), 1),
              _createElementVNode("span", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(_toDisplayString(__props.nfo?.scrape_result?.year || '无'), 1)
              ]),
              (_unref(userUploadInfo))
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", {
                      innerHTML: _unref(userUploadInfo),
                      onClick: showUploadDetail
                    }, null, 8, _hoisted_11),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(["origin info-row", _unref(userUploadInfo) ? 'mt-8' : 'mt-24'])
              }, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_unref(infoOrigin)), 1)
              ], 2),
              _createElementVNode("p", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(_toDisplayString(__props.nfo?.video_info?.file_name), 1)
              ])
            ])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(problemTypes), (problem) => {
              return (_openBlock(), _createElementBlock("span", {
                key: problem.id,
                class: _normalizeClass([{
              'check': true,
              'is-checked': _unref(isProblemChecked)(problem.id)
            }, "check"]),
                onClick: ($event: any) => (_unref(checkProblem)(problem.id))
              }, _toDisplayString(problem.text), 11, _hoisted_18))
            }), 128))
          ]),
          _hoisted_19,
          _withDirectives(_createElementVNode("textarea", {
            class: "addition",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(additionRef) ? (additionRef).value = $event : null)),
            placeholder: "请输入你要补充的内容",
            maxlength: "100"
          }, null, 512), [
            [_vModelText, _unref(additionRef)]
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(Button, {
            onClick: onConfirm,
            text: "提交",
            size: "middle",
            disabled: _unref(isSubmitDisabled)
          }, null, 8, ["disabled"]),
          _createVNode(Button, {
            onClick: _unref(close),
            text: "取消",
            type: "cancel",
            size: "middle"
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["close", "is-show"]))
}
}

})